/* RESPONSIBLE TEAM: team-standalone */
import Route from '@ember/routing/route';

export default class Workflow extends Route {}
